import React from 'react'
import { Helmet } from 'react-helmet';
import { EventsData } from '../data/EventsData';
import { Link } from 'react-router-dom';


const EventsHosted = () => {
    const LeaguesFilteredData = EventsData.filter((events) => events.PageClassification === "Events Hosted");
    return (
        <div>
            <Helmet>
                <title>Events | Events Hosted</title>
            </Helmet>
            <div className='main-container'>
            <div className="page-bg"></div>
        <div className="page-bg page-bg2"></div>
        <div className="page-bg page-bg3"></div>
                <div className="section">
                    <div className="page-heading">
                        <h1>Events Hosted</h1>
                    </div>
                    <div className="grid-3">
                        {LeaguesFilteredData.map((event, index) => {
                            return (
                                <div className='card-item' key={index}>
                                    {event.Para1 ? (
                                        <Link to={`/events/${event.EventName}`} onClick={() => window.scrollTo(0, 0)}>
                                            <div className="card-item-image">
                                                <img src={event.CardImage} alt='Events' />

                                            </div>
                                            <div className="card-item-caption">
                                                <h2>{event.EventName}</h2>
                                            </div>



                                        </Link>

                                    ) : (

                                        <>
                                            <div className="card-item-image">
                                                <img src={event.CardImage} alt='Events' />

                                            </div>
                                            <div className="card-item-caption">
                                                <h2>{event.EventName}</h2>
                                            </div>
                                        </>

                                    )}

                                </div>

                            )
                        })}
                    </div>





                </div>

            </div>

        </div>
    )
}

export default EventsHosted